"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationInitiationSource = void 0;
exports.ConversationInitiationSource = {
    Unknown: "unknown",
    AndroidSdk: "android_sdk",
    NodeJsSdk: "node_js_sdk",
    ReactNativeSdk: "react_native_sdk",
    ReactSdk: "react_sdk",
    JsSdk: "js_sdk",
    PythonSdk: "python_sdk",
    Widget: "widget",
    SipTrunk: "sip_trunk",
    Twilio: "twilio",
    Genesys: "genesys",
};
